import React from "react";
import { Gift, ArrowRight } from "lucide-react";
import { PLANITY_URL } from "@/data/content";
import { Reveal } from "./Reveal";

const BORDEAUX = "#5a2b2b";
const CHAMPAGNE = "#f0e6cf";
const GOLD = "#e3c37a";

export const GiftCard = () => {
  return (
    <section id="carte-cadeau" data-testid="gift-card-section" className="bg-white">
      <Reveal className="max-w-3xl mx-auto px-6 py-16 md:py-20">
        <div
          className="relative rounded-2xl px-7 py-10 md:px-14 md:py-12 text-center overflow-hidden"
          style={{ backgroundColor: BORDEAUX }}
        >
          {/* fin trait décoratif or champagne scintillant */}
          <span
            aria-hidden="true"
            className="gold-champagne-bar mx-auto mb-6 block h-px w-10"
          />

          <Gift
            size={26}
            strokeWidth={1.4}
            className="mx-auto mb-5"
            style={{ color: GOLD }}
            aria-hidden="true"
          />

          <h2
            className="font-serif-display font-light text-3xl md:text-4xl"
            style={{ color: CHAMPAGNE }}
          >
            Offrir une carte cadeau
          </h2>
          <p
            className="mt-4 mx-auto max-w-md text-sm md:text-base leading-relaxed"
            style={{ color: CHAMPAGNE, opacity: 0.85 }}
          >
            Une attention à offrir, à choisir parmi les soins et prestations
            Ninaa Beauty.
          </p>

          <a
            href={PLANITY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gift-card-cta"
            className="group mt-8 inline-flex items-center gap-2 text-sm tracking-wide transition-opacity hover:opacity-80"
          >
            <span className="gold-champagne underline decoration-1 underline-offset-[6px] decoration-[#e3c37a]/60">J’offre un moment ♡</span>
            <ArrowRight
              size={15}
              style={{ color: GOLD }}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </a>
        </div>
      </Reveal>
    </section>
  );
};
